import ExbnTaxonomyForm from './exbn-taxonomy-form'

export default ExbnTaxonomyForm;